import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import { store } from "./Store/store";
// import { Provider, useSelector } from "react-redux";
// import store from "./Store/store";
// import { ConfigProvider } from "antd";
// import { theme } from "antd";


const root = ReactDOM.createRoot(document.getElementById("root"));


// const mode = useSelector((state) => state.darkMode);

// const { isdarkMode } = mode;
// console.log(isdarkMode)

root.render(
  <React.StrictMode>
    {/* <Provider store={store}> */}
      {/* <ConfigProvider  
        theme={{
          
          // algorithm: isdarkMode? theme.darkAlgorithm: '',

          token: {
            
            colorPrimary: "#ffffff",
            borderRadius: 2,
            colorBgContainer: "#000000",
          },

         

        }}

        
      > */}
        <App />
      {/* </ConfigProvider> */}
    {/* </Provider> */}
  </React.StrictMode>
);


